import { Routes } from "../../constants/Routes";
import { PaginatingTableController } from "../sharedControllers/PaginatingTableController";

/**
 * @namespace akademika.akamont.pages.contractList
 */
export default class ContractList extends PaginatingTableController {
  route = Routes.CONTRACT_LIST;
  parentRoute = Routes.DASHBOARD;
  getContractListUri = "api/Contract/GetContractList";

  public onInit() {
    super.onInit();
    const defaultFilters = {
      sapId: "",
      buyerName: "",
      contractType: "",
      showDeleted: false,
    };
    this.initFilters(defaultFilters, this.getContractListUri);
  }

  public async onRouteMatched() {
    await this.fetchModel("api/Contract/GetContractFilterOptions", "filterOptions");
  }

  public async onContractDetails(contractId: number) {
    this.navTo(Routes.CONTRACT_DETAILS, { id: contractId });
  }

  public async onNewContract() {
    this.navTo(Routes.CONTRACT_ADD);
  }
}
